import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dwyztnoyyfzyijovgrhn.supabase.co'
const supabaseAnonKey = 'sb_publishable_zH8IOR9Rk3skwGPF2EzYtQ_W4R4DNND'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
